import { baseTheme } from "@xingternal/winery-ui/lib/theme";

type MEDIA_SIZES_PROPS = {
  LARGE: string;
  MEDIUM_AND_MORE: string;
  XXLARGE: string;
};

// Mobile-first approach (using min-width) using Winery theme breakpoints' values.
// From Winery's theme: const breakpoints = ['640px', '768px', '1024px', '1200px'];
const [THRESHOLD_MEDIUM, , THRESHOLD_LARGE] = baseTheme.breakpoints;
export const MEDIA_SIZES: MEDIA_SIZES_PROPS = {
  MEDIUM_AND_MORE: `@media screen and (min-width: ${THRESHOLD_MEDIUM})`, // >640
  LARGE: `@media screen and (min-width: ${THRESHOLD_LARGE})`, // >1024
  XXLARGE: `@media screen and (min-width: 1280px)`, // >1280
};

// Use MEDIA_CUSTOM just for edge cases where intermediate breakpoint are absolutely required,
// but you don't want to pollute MEDIA_SIZES with non-standard breakpoints
export const MEDIA_CUSTOM = (width: string) =>
  `@media screen and (min-width: ${width})`;

export const MEDIA_IE =
  '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)';
